import * as React from 'react';
import { CHANNEL_HEX, type ChannelKey } from '@/lib/dashboard/channels';


const AVATAR_TINT: Record<ChannelKey, { bg: string; text: string; ring: string }> = {
  whatsapp: { bg: '#E7F7EC', text: '#027A48', ring: '#D1FADF' },
  instagram: { bg: '#FDF2F8', text: '#BE185D', ring: '#FBCFE8' },
  facebook: { bg: '#EFF6FF', text: '#1D4ED8', ring: '#BFDBFE' },
  linkedin: { bg: '#EFF6FF', text: '#0A66C2', ring: '#BFDBFE' },
  youtube: { bg: '#FEF2F2', text: '#CC0000', ring: '#FECACA' },
  ads: { bg: '#FFFBEB', text: '#B45309', ring: '#FDE68A' },
  website: { bg: '#F1F5F9', text: '#475569', ring: '#E2E8F0' },
  referral: { bg: '#EEF2FF', text: '#4338CA', ring: '#C7D2FE' },
};

export const CHANNEL_GLYPH: Record<ChannelKey, React.ReactNode> = {
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.04A9.96 9.96 0 0 0 2.04 12c0 1.76.46 3.42 1.26 4.86L2 22l5.28-1.26A9.96 9.96 0 1 0 12 2.04zm5.62 14.2c-.24.66-1.38 1.22-1.9 1.28-.5.06-1.12.08-1.8-.12-.42-.12-.96-.3-1.66-.58-2.92-1.26-4.82-4.2-4.96-4.4-.14-.2-1.16-1.54-1.16-2.94s.74-2.08 1-2.36c.24-.28.54-.36.72-.36h.52c.16 0 .4-.06.62.48.24.58.8 2 .88 2.14.08.14.12.3.02.48-.1.2-.14.32-.28.5-.14.16-.3.36-.42.48-.14.14-.28.28-.12.56.16.28.7 1.16 1.5 1.88 1.04.92 1.9 1.2 2.18 1.34.28.14.44.12.6-.06.18-.2.74-.86.94-1.16.2-.3.4-.24.66-.14.28.1 1.72.82 2.02.96.3.14.5.22.58.34.08.14.08.78-.16 1.44z" />
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 7.2A4.8 4.8 0 1 0 12 16.8 4.8 4.8 0 0 0 12 7.2zm0 7.92a3.12 3.12 0 1 1 0-6.24 3.12 3.12 0 0 1 0 6.24zM17.64 6.96a1.12 1.12 0 1 1-2.24 0 1.12 1.12 0 0 1 2.24 0z" />
      <path d="M12 2.4c-2.6 0-2.93.01-3.96.06-2.66.12-3.9 1.36-4.02 4.02C3.97 7.51 3.96 7.84 3.96 10.44s.01 2.93.06 3.96c.12 2.66 1.36 3.9 4.02 4.02 1.03.05 1.36.06 3.96.06s2.93-.01 3.96-.06c2.66-.12 3.9-1.36 4.02-4.02.05-1.03.06-1.36.06-3.96s-.01-2.93-.06-3.96c-.12-2.66-1.36-3.9-4.02-4.02C14.93 2.41 14.6 2.4 12 2.4zm0 1.68c2.56 0 2.86.01 3.86.06 1.94.09 2.83.98 2.92 2.92.05 1 .06 1.3.06 3.86s-.01 2.86-.06 3.86c-.09 1.94-.98 2.83-2.92 2.92-1 .05-1.3.06-3.86.06s-2.86-.01-3.86-.06c-1.94-.09-2.83-.98-2.92-2.92-.05-1-.06-1.3-.06-3.86s.01-2.86.06-3.86c.09-1.94.98-2.83 2.92-2.92 1-.05 1.3-.06 3.86-.06z" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M13.5 21v-8h2.7l.4-3.2h-3.1V7.7c0-.9.3-1.6 1.6-1.6h1.7V3.2C16.5 3.1 15.5 3 14.4 3c-2.4 0-4 1.5-4 4.1v2.7H7.7V13h2.7v8h3.1z" />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.03-1.85-3.03-1.85 0-2.14 1.44-2.14 2.94v5.66H9.36V9h3.41v1.56h.05c.47-.9 1.62-1.85 3.34-1.85 3.58 0 4.24 2.36 4.24 5.43v6.31zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45z" />
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M23.5 6.2c-.3-1.1-1.1-1.9-2.2-2.2C19.4 3.5 12 3.5 12 3.5s-7.4 0-9.3.5c-1.1.3-1.9 1.1-2.2 2.2C0 8.1 0 12 0 12s0 3.9.5 5.8c.3 1.1 1.1 1.9 2.2 2.2 1.9.5 9.3.5 9.3.5s7.4 0 9.3-.5c1.1-.3 1.9-1.1 2.2-2.2.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.5V8.5l6.4 3.5-6.4 3.5z" />
    </svg>
  ),
  ads: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    </svg>
  ),
  website: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z" />
    </svg>
  ),
  referral: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    </svg>
  ),
};

export function ChannelIcon({ channel }: { channel: ChannelKey }) {
  return (
    <span
      className="shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-white"
      style={{ background: CHANNEL_HEX[channel] }}
    >
      <span className="w-3.5 h-3.5">{CHANNEL_GLYPH[channel]}</span>
    </span>
  );
}

const INBOX_LOGO: Partial<Record<ChannelKey, string>> = {
  whatsapp: '/assets/social-media/whatsapp-icon-logo-svgrepo-com.svg',
  instagram: '/assets/social-media/instagram-icon.svg',
  facebook: '/assets/social-media/facebook-icon.svg',
};

export interface ChannelAvatarProps {
  initials: string;
  channel: ChannelKey;
  ring?: boolean;
  badge?: 'tile' | 'inbox';
}

export function ChannelAvatar({ initials, channel, ring = false, badge = 'tile' }: ChannelAvatarProps) {
  const tint = AVATAR_TINT[channel];
  const inboxLogo = badge === 'inbox' ? INBOX_LOGO[channel] : undefined;

  return (
    <span className="relative shrink-0">
      <span
        className="w-10 h-10 rounded-full text-[12px] font-semibold flex items-center justify-center"
        style={{
          background: tint.bg,
          color: tint.text,
          boxShadow: ring ? `0 0 0 2px ${tint.ring}` : undefined,
        }}
      >
        {initials}
      </span>
      {inboxLogo ? (
        <span className="absolute -bottom-0.5 -right-0.5 h-[18px] w-[18px] overflow-hidden rounded-full bg-white ring-2 ring-white">
          <img src={inboxLogo} alt="" aria-hidden className="h-full w-full rounded-full object-cover" />
        </span>
      ) : (
        <span className="absolute -bottom-0.5 -right-0.5 scale-[0.85] origin-bottom-right rounded-md ring-2 ring-white">
          <ChannelIcon channel={channel} />
        </span>
      )}
    </span>
  );
}
